import { Suspense } from 'react';
import { TanStackQueryDevtools } from '../devtools/tanstack-query';
import { TanStackRouterDevtools } from '../devtools/tanstack-router';

function RootDocument({ children }: { children: React.ReactNode }) {
  return (
    <>
      {children}
      {/* <ScrollRestoration /> if needed */}
      {/* <TailwindScreenDevtools /> if needed */}
      <div className="DevtoolsWrapper">
        <Suspense fallback={<div>Loading Devtools ...</div>}>
          <TanStackQueryDevtools />
          <TanStackRouterDevtools />
        </Suspense>
      </div>
    </>
  );
}
export { RootDocument };
